import React from 'react';
import { Link } from 'react-router-dom';

import Auth from './Auth';

const Header = () => {
    return (
        <div className='bar'>
                     <Link to='/' className='brand'>
                     Caredevo
                    </Link>
           
                <div style={{ float:'right', marginTop:'5px'}}>
    
                    <Auth />
                </div>
        </div>
    );
};

export default Header;